import React, { useState } from 'react';
import PropTypes from 'prop-types';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const EmailVerificationBanner = ({ className }) => {
  const { user } = useAuth();
  const [status, setStatus] = useState({ loading: false, success: '', error: '' });

  const needsVerification = Number(user?.validEmail) === 0;
  const userUuid =
    user?.uuid || user?.Uuid || user?.userUuid || user?.UserUuid || user?.id || user?.ID || null;

  if (!needsVerification) {
    return null;
  }

  const handleRequest = async () => {
    if (!userUuid || status.loading) return;

    try {
      setStatus({ loading: true, success: '', error: '' });
      await api.post('/account/verify-email', { userUuid });
      setStatus({
        loading: false,
        success:
          'Enviamos um novo email de confirmação. Confira sua caixa de entrada (e o spam, se necessário).',
        error: '',
      });
    } catch (error) {
      setStatus({
        loading: false,
        success: '',
        error:
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          'Não foi possível solicitar a verificação. Tente novamente em instantes.',
      });
    }
  };

  return (
    <div
      className={`mb-6 rounded-2xl border border-amber-200 bg-amber-50 px-6 py-4 text-sm text-amber-900 shadow-sm ${className}`}
      role="alert"
    >
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-3">
          <i className="bi-exclamation-triangle-fill text-lg mt-0.5" aria-hidden="true"></i>
          <div>
            <p className="font-semibold text-amber-900">Confirme seu email</p>
            <p className="text-xs sm:text-sm text-amber-800">
              O seu endereço de email ainda não foi verificado. Valide seu email para
              continuar usando todos os recursos da Stackfy.
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={handleRequest}
          disabled={status.loading || !userUuid}
          className="inline-flex items-center justify-center gap-2 rounded-full bg-amber-500 px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-amber-600 disabled:opacity-70 disabled:cursor-not-allowed"
        >
          {status.loading ? 'Enviando...' : 'Enviar email de verificação'}
          <i className="bi-envelope-check" aria-hidden="true"></i>
        </button>
      </div>
      {status.success ? (
        <p className="mt-3 text-xs text-emerald-700 font-medium">{status.success}</p>
      ) : null}
      {status.error ? (
        <p className="mt-3 text-xs text-red-600 font-medium">{status.error}</p>
      ) : null}
    </div>
  );
};

EmailVerificationBanner.propTypes = {
  className: PropTypes.string,
};

EmailVerificationBanner.defaultProps = {
  className: '',
};

export default EmailVerificationBanner;

